/**
 * Maps workspace names to their section codes for Execution area
 */
export const WORKSPACE_SECTION_MAP: Record<string, string> = {
  "Employee Benefits Expense": "EBE",
  "Lease Liability": "LEASE",
  "Lease Liability - Ind AS": "LEASE",
  "Right-of-Use Assets": "ROU",
  "Trade Payables": "TP",
  "Inventory": "INV",
  "Cash & Cash Equivalents": "CCE",
  "Finance Cost": "FINCO",
  "Income Tax": "ITAX",
  "Investments": "INVST",
  "Other Assets": "OTAS",
  "Other Financial Assets": "OFA",
  "Other Income": "OTINC",
  "Revenue from Operations": "RFO",
  "Property, Plant & Equipment": "PPE",
  "Other Liabilities": "OTL",
  "Other Financial Liabilities": "OFL",
  "Other Receivables": "OTR",
  "Opening Balance Testing": "OBT",
  "Related Party Disclosure": "RPT",
  "Equity": "EQU",
  "Management Use of Expert": "MUE",
  "Use of Auditor's Specialist": "UAS",
  "Intangible Assets": "IT",
  "Depreciation": "DEPR",
  "Impairment Testing": "IMPR",
  "Trade Receivables": "TR",
  "Other Expenses": "OTEX",
  "Borrowings": "DEBT",
  "Borrowings - Ind AS": "DEBT",
  "Cost of Materials Consumed": "COGS",
  "Secretarial Compliance": "SECR",
  "Incentives": "INCT",
  "Valuation": "VAL",
  "Contract Assets": "CONA",
  "Provisions & Contingent Liabilities": "PCL",
  "Provisions and Contingent Liabilities": "PCL",
  "Financial Closing & Reporting Process": "FCRP",
  "Management Override of Controls": "MOC",
  "Biological Assets other than Bearer Plants": "BAPB",
};

/**
 * Gets the section code for a workspace name
 * @param workspaceName The workspace name
 * @returns The section code (e.g., "EBE", "TP", etc.)
 */
export function getSectionCode(workspaceName: string): string {
  return WORKSPACE_SECTION_MAP[workspaceName] || "";
}

/**
 * Gets the full section key for document list (e.g., "Execution_EBE")
 * @param workspaceName The workspace name
 * @returns The section key
 */
export function getDocumentSectionKey(workspaceName: string): string {
  const code = getSectionCode(workspaceName);
  return code ? `Execution_${code}` : "";
}

/**
 * Gets the section list for IPE/IUC (e.g., ["Execution_EBE_File"])
 * @param workspaceName The workspace name
 * @returns The section list array
 */
export function getFileSectionList(workspaceName: string): string[] {
  const code = getSectionCode(workspaceName);
  return code ? [`Execution_${code}_File`] : [];
}

